module.exports = __webpack_public_path__ + "img/onboarding-profile-person.d7a44351.svg";